window.switches = []
window.switche = require('weatherstar-switch')
window.cookies = require('js-cookie')
